// Store/api/gymsApi.js
import { createApi } from "@reduxjs/toolkit/query/react";
import { customFetchBase } from "../customFetchBase";

export const gymsApi = createApi({
  reducerPath: "gymsApi",
  baseQuery: customFetchBase({ url: "gym" }),
  endpoints: (builder) => ({
    // Get all gyms with filters
    getGyms: builder.query({
      query: (params = {}) => {
        const {
          page = 1,
          limit = 10,
          search,
          province,
          city,
          area,
          sport,
          genderType,
          isActive,
          isDiscount,
          minRating,
          sort = "-rating_stats.average_rating,-rating_stats.total_reviews",
        } = params;

        let url = `?page=${page}&limit=${limit}`;

        if (search) url += `&q=${search}`;
        if (province) url += `&location.province[eq]=${province}`;
        if (city) url += `&location.city[eq]=${city}`;
        if (area) url += `&location.areas[eq]=${area}`;
        if (sport) url += `&sport[eq]=${sport}`;
        if (genderType) url += `&genderType=${genderType}`;
        if (isActive !== undefined) url += `&isActive=${isActive}`;
        if (isDiscount !== undefined) url += `&isDiscount=${isDiscount}`;
        if (minRating) url += `&minRating=${minRating}`;
        if (sort) url += `&sort=${sort}`;

        return { url, method: "GET" };
      },
    }),

    // Get single gym by ID
    getGymById: builder.query({
      query: (id) => ({
        url: `/${id}`,
        method: "GET",
      }),
    }),

    // Create new gym
    createGym: builder.mutation({
      query: (data) => ({
        url: "/",
        method: "POST",
        body: data,
      }),
    }),

    // Update gym
    updateGym: builder.mutation({
      query: ({ id, data }) => ({
        url: `/${id}`,
        method: "PATCH",
        body: data,
      }),
    }),

    // Toggle gym active status
    toggleGymStatus: builder.mutation({
      query: (id) => ({
        url: `/status/${id}`,
        method: "PATCH",
      }),
    }),
  }),
});

// Export hooks
export const {
  useGetGymsQuery,
  useGetGymByIdQuery,
  useCreateGymMutation,
  useUpdateGymMutation,
  useToggleGymStatusMutation,
} = gymsApi;
